var _rect, _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconMail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 35,
    viewBox: "0 0 37 35",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 1.19922,
    y: 1,
    width: 34,
    height: 33,
    rx: 7,
    stroke: "#BABABA",
    strokeWidth: 2
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.1992 11.5C28.1992 10.4 27.2992 9.5 26.1992 9.5H10.1992C9.09922 9.5 8.19922 10.4 8.19922 11.5V23.5C8.19922 24.6 9.09922 25.5 10.1992 25.5H26.1992C27.2992 25.5 28.1992 24.6 28.1992 23.5V11.5ZM26.1992 11.5L18.1992 16.5L10.1992 11.5H26.1992ZM26.1992 23.5H10.1992V13.5L18.1992 18.5L26.1992 13.5V23.5Z",
    fill: "#04245C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.1992 11.5C28.1992 10.4 27.2992 9.5 26.1992 9.5H10.1992C9.09922 9.5 8.19922 10.4 8.19922 11.5V23.5C8.19922 24.6 9.09922 25.5 10.1992 25.5H26.1992C27.2992 25.5 28.1992 24.6 28.1992 23.5V11.5ZM26.1992 11.5L18.1992 16.5L10.1992 11.5H26.1992ZM26.1992 23.5H10.1992V13.5L18.1992 18.5L26.1992 13.5V23.5Z",
    fill: "#04245C"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M18.1992 18.5L10.1992 13.5V11.5L18.1992 16.5L26.1992 11.5V13.5L18.1992 18.5Z",
    fill: "#2173FF"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconMail);
export default __webpack_public_path__ + "static/media/icon_mail.aeb7dc95db38f0f8e9e94fc7c46e7dc7.svg";
export { ForwardRef as ReactComponent };